import moment from 'moment';

// Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// HACK: disobeys folder structure rules
import {
    selectFirstDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import { makeSelectMyTimesheetEntriesDateTotal } from 'services/myTimesheetEntries/selectors';

// Global Utils
import minutesToHours from 'utils/minutes-to-hours';

// Local Types
import { OwnProps } from './types';

const selectDayOfWeek = (state: AppState, props: OwnProps): number =>
    props.dayOfWeek;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeSelectMyTimesheetEntriesDayTotal = () =>
    createDeepEqualSelector(
        [(state: AppState) => state, selectFirstDate, selectDayOfWeek],
        (state, firstDateState: string, dayOfWeekProp): string => {
            const date = moment(firstDateState, 'YYYY-MM-DD')
                .add(dayOfWeekProp, 'days')
                .format('YYYY-MM-DD');
            const totalMinutes = makeSelectMyTimesheetEntriesDateTotal(date)(
                state
            );
            return minutesToHours(totalMinutes);
        }
    );

export { makeSelectMyTimesheetEntriesDayTotal };
